<template>
  <b-form @submit.prevent="submit()">
    <div class="justify-content-md-center customer-info-form boxes">
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="first_name" v-if="isIE">First Name*</label>
          <b-form-group label="" label-for="first_name">
            <div data-for="first_name" class="placeholder-label">First Name*</div>
            <b-form-input id="first_name" type="text" v-model.trim="addressData.first_name" :placeholder="placeholders.first_name" class="customer"></b-form-input>
            <div v-if="fieldErrors.first_name" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.first_name }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="last_name" v-if="isIE">Last Name*</label>
          <b-form-group label="" label-for="last_name">
            <div data-for="last_name" class="placeholder-label">Last Name*</div>
            <b-form-input id="last_name" type="text" v-model.trim="addressData.last_name" :placeholder="placeholders.last_name" class="customer"></b-form-input>
            <div v-if="fieldErrors.last_name" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.last_name }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="address1" v-if="isIE">Street Address*</label>
          <b-form-group label="" label-for="address1">
            <div data-for="address1" class="placeholder-label">Street Address*</div>
            <b-form-input id="address1" type="text" v-model.trim="addressData.address1" :placeholder="placeholders.address1" class="customer"></b-form-input>
            <div v-if="fieldErrors.address1" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.address1 }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="address2" v-if="isIE">Street Address 2</label>
          <b-form-group label="" label-for="address2">
            <div data-for="address2" class="placeholder-label">Street Address 2</div>
            <b-form-input id="address2" type="text" v-model.trim="addressData.address2" :placeholder="placeholders.address2" class="customer"></b-form-input>
            <div v-if="fieldErrors.address2" class="text-danger input-error text-right pr-2">
              <small>{{ fieldErrors.address2 }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="city" v-if="isIE">City*</label>
          <b-form-group label="" label-for="city">
            <div data-for="city" class="placeholder-label">City*</div>
            <b-form-input id="city" type="text" v-model.trim="addressData.city" :placeholder="placeholders.city" class="customer"></b-form-input>
            <div v-if="fieldErrors.city" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.city }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="country" v-if="isIE">Country*</label>
          <b-form-group label="" label-for="country">
            <div data-for="country" class="placeholder-label">Country*</div>
            <b-form-select id="country" v-model="addressData.country" :options="countries" :placeholder="placeholders.country" @change="countryChanged" class="customer select"></b-form-select>
            <div v-if="fieldErrors.country" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.country }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-pd pr-0">
          <label for="state" v-if="isIE">State</label>
          <b-form-group label="" label-for="state">
            <div data-for="state" class="placeholder-label">State</div>
            <b-form-select v-if="isUsOrCA()" id="state" v-model="addressData.state" :options="getStates()" :placeholder="placeholders.state" class="customer select"></b-form-select>
            <b-form-input v-if="!isUsOrCA()" id="state" type="text" v-model.trim="addressData.state" :placeholder="placeholders.state" class="customer"></b-form-input>
            <div v-if="fieldErrors.state" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.state }}</small>
            </div>
          </b-form-group>
        </b-col>
        <b-col class="col-pd-right">
          <label for="zip" v-if="isIE">Zip Code*</label>
          <b-form-group label="" label-for="zip">
            <div data-for="zip" class="placeholder-label">Zip Code*</div>
            <b-form-input id="zip" :formatter="zipFormat" type="text" v-model.trim="addressData.zip" :placeholder="placeholders.zip" class="customer"></b-form-input>
            <div v-if="fieldErrors.zip" class="text-danger input-error text-right pr-1">
              <small>{{ fieldErrors.zip }}</small>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="input" class="justify-content-md-center boxes">
      <b-col md="6" lg="6" class="pl-sm-0 pr-sm-0">
        <b-row class="justify-content-md-center boxes customer-verify-btn customer-verify">
          <b-col md="6" cols="6">
            <b-button block @click="$emit('goBack')" class="btn-outline-success btn-back" variant="outline-success">Back</b-button>
          </b-col>
          <b-col md="6" cols="6">
            <b-button block type="submit" class="btn btn-default btn-account" variant="primary">
            <span v-html="input.formatted_label"></span>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
import {formatZipField, getCountryStates, isCountryUSOrCA, updateRequiredFields, getCountries} from '@/utils'

export default {
  name: 'CustomerInfoForm',
  props: {
    placeholders: Object,
    addressData: Object,
    input: Object,
    responseErrors: Object
  },
  data: function() {
    return {
      fieldErrors: {}
    }
  },
  watch: {
    'addressData': {
      handler: function(val) {
        this.fieldErrors = {}
        this.validateInformation()
      },
      deep: true
    },
    'responseErrors': {
      handler: function(val) {
        let errors = {...this.fieldErrors}
        this.fieldErrors = {}

        Object.keys(val).forEach(key => {
          if (val[key]) {
            errors[key.replace('ship_', '')] = val[key][0]
          }
        })
        this.fieldErrors = errors
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['session', 'isIE', 'campaign']),
    countries() {
      return getCountries(this.session)
    }
  },
  methods: {
    submit: function() {
      if (this.validateInformation()) {
        this.$emit('submit', this.addressData)
      }
    },
    validateInformation: function() {
      let requiredFields = [
        'first_name',
        'last_name',
        'address1',
        'city',
        'zip',
        'country'
      ]
      updateRequiredFields(requiredFields, this.addressData.country)

      let valid = true
      let existingFieldsErrors = {...this.fieldErrors}
      requiredFields.forEach(field => {
        let value = this.addressData[field]
        existingFieldsErrors[field] = null
        if (!value || value.length < 1) {
          existingFieldsErrors[field] = 'This field is required.'
          valid = false
        }
        if (field === 'zip' && value && this.isUsOrCA() && value.length < 5) {
          existingFieldsErrors[field] = 'Invalid Zip Code'
        }
      })
      this.fieldErrors = existingFieldsErrors
      return valid
    },
    getStates() {
      return getCountryStates(this.addressData.country, this.campaign.blacklisted_states)
    },
    countryChanged() {
      this.addressData.state = ''
      this.addressData.zip = ''
    },
    isUsOrCA() {
      return isCountryUSOrCA(this.addressData.country)
    },
    zipFormat(value) {
      return formatZipField(value, this.addressData.country)
    }
  },

  created() {
    if (this.addressData && this.addressData.country) {
      this.addressData.country = this.addressData.country.toUpperCase()
    }
  }

}
</script>

<style scoped lang="less">

  .customer-info-form {
    padding: 1.2rem 1.2rem 0;

    .form-control {
      padding: 0 0.8rem;
      font-size: 16px !important;
      color: #4D4D4DCC !important;
      box-shadow: none !important;
      border-radius: 4px !important;
      border: 0.4px solid #d9d9d9 !important;
    }

    .select {
      padding: 0 0.8rem;
      color: #4D4D4DCC;
      font-size: 16px !important;
      box-shadow: none !important;
      background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='24' height='24' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='black'/></g></svg>") no-repeat right 0.75rem center/14px 20px;
    }

    .input-error {
      small {
        font-size: 11px;
      }
    }
  }

  @media only screen and (min-width: 576px) {
    .customer-info-form {
      padding: 1.8rem 2rem 0;

      .form-control {
        padding: 0 1.2rem;
      }

      .select {
        padding: 0 1.2rem;
      }
    }
  }
</style>
